<template>
	<div class="dashboard-home">
		<div class="content-block">
			<div style="width: 100%; max-width: 1024px;">
				<img src="@/assets/colpuno_big_transparent.png" style="width: 100%;" />
				<div class="dx-card" style="padding: 20px; width:100%; display: flex; flex-direction: column; align-items: center; text-align: center;">
					<div style="margin-bottom: 1em; font-size: 24px; font-weight: bold; text-decoration: underline;">Coming Soon!</div>
					<div style="margin-bottom: 1em; font-size: 18px;">Are you ready to take charge of your nursing career?</div>
					<div style="margin-bottom: 1em; max-width: 600px; font-style: italic;">At COLPUNO, we are creating a platform tailored specifically for Filipino nurses, empowering you to showcase your skills, connect with top employers, and achieve your career dreams.</div>
					<div style="margin-bottom: 1em;">Be among the first to join a game-changing platform where employers apply to YOU.</div>
					<div style="margin-top: 3em; display: flex; flex-direction: row; gap: 20px; justify-content: space-evenly; width: 100%; text-transform: uppercase;">
						<div class="hoverlink">
							<router-link to="/survey/general">
								<img src="@/assets/stock_survey.png" style="width:100%; max-width: 256px; border-radius: 20px;" />
								<div style="margin-top: 1em;">Join our Survey!</div>
							</router-link>
						</div>
						<div class="hoverlink">
							<a href="https://www.colpuno.com/">
								<img src="@/assets/stock_rocket.png" style="width:100%; max-width: 256px; border-radius: 20px;" />
								<div style="margin-top: 1em;">Return to the homepage</div>
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style>
.hoverlink:hover {
	cursor: pointer;
	transform: scale(1.05);
}
.hoverlink:hover a {
	text-decoration: underline;
}
.hoverlink a {
	text-decoration: none;
	color: #333;
	font-size: 14px;
	font-weight: bold;
}
</style>
